<template>
  <footer class="footer-section">
    <div class="container">
      <div class="footer-content">
        <div class="footer-main">
          <div class="brand-section">
            <h3 class="brand-name">GAC Code</h3>
            <p class="brand-description">
              国内稳定的 Claude Code 镜像服务，提供积分制度和智能回血机制，让中国开发者享受更稳定、更经济的 AI 编程体验。
            </p>
            <div class="demo-notice">
              <span class="demo-badge">💭 本站仅作展示用途</span>
            </div>
          </div>
          
          <div class="footer-links">
            <div class="link-column">
              <h4 class="column-title">产品</h4>
              <ul class="link-list">
                <li><a href="https://docs.anthropic.com/en/docs/claude-code" target="_blank">官方文档</a></li>
                <li><a href="#pricing">套餐价格</a></li>
                <li><a href="#features">功能特色</a></li>
                <li><a href="#get-started">快速开始</a></li>
              </ul>
            </div>
            
            <div class="link-column">
              <h4 class="column-title">资源</h4>
              <ul class="link-list">
                <li><a href="https://docs.anthropic.com/en/docs/claude-code/common-workflows" target="_blank">使用教程</a></li>
                <li><span class="disabled-link">技术支持</span></li>
                <li><a href="https://docs.anthropic.com/en/docs/claude-code/troubleshooting" target="_blank">故障排除</a></li>
                <li><a href="https://docs.anthropic.com/en/docs/claude-code/cli-reference" target="_blank">API 参考</a></li>
              </ul>
            </div>
            
            <div class="link-column">
              <h4 class="column-title">服务</h4>
              <ul class="link-list">
                <li><a href="#pricing">套餐对比</a></li>
                <li><span class="disabled-link">客服邮箱</span></li>
                <li><a href="https://anthropic.com" target="_blank">关于 Anthropic</a></li>
                <li><a href="https://claudecode.io/pricing" target="_blank">官方价格</a></li>
              </ul>
            </div>
            
            <div class="link-column">
              <h4 class="column-title">条款</h4>
              <ul class="link-list">
                <li><a href="https://anthropic.com/privacy" target="_blank">隐私政策</a></li>
                <li><a href="https://anthropic.com/terms" target="_blank">服务条款</a></li>
                <li><a href="https://anthropic.com/security" target="_blank">安全保障</a></li>
                <li><a href="https://docs.anthropic.com/en/docs/claude-code/security" target="_blank">数据处理</a></li>
              </ul>
            </div>
          </div>
        </div>
        
        <div class="footer-bottom">
          <div class="footer-divider"></div>
          <div class="footer-meta">
            <p class="copyright">
              © 2025 此站仅作展示用途，不提供实际服务。
            </p>
            <div class="footer-badges">
              <span class="badge">🌐 国内镜像</span>
              <span class="badge">🔄 积分回血</span>
              <span class="badge">⚡ 99.9% 稳定性</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'FooterSection'
}
</script>

<style scoped>
.footer-section {
  background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%);
  color: white;
  padding: 80px 0 20px;
}

.footer-content {
  width: 100%;
}

.footer-main {
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: 80px;
  margin-bottom: 60px;
}

.brand-section {
  max-width: 400px;
}

.brand-name {
  font-size: 1.5rem;
  font-weight: 700;
  margin-bottom: 16px;
  color: white;
}

.brand-description {
  color: #cbd5e1;
  line-height: 1.6;
  margin-bottom: 24px;
}

.social-links {
  display: flex;
  gap: 16px;
}

.social-link {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background: rgba(59, 130, 246, 0.1);
  border-radius: 8px;
  transition: all 0.3s ease;
  text-decoration: none;
}

.social-link:hover {
  background: rgba(59, 130, 246, 0.2);
  transform: translateY(-2px);
}

.social-icon {
  font-size: 1.25rem;
}

.footer-links {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 40px;
}

.column-title {
  font-size: 1rem;
  font-weight: 600;
  color: white;
  margin-bottom: 20px;
}

.link-list {
  list-style: none;
}

.link-list li {
  margin-bottom: 12px;
}

.link-list a {
  color: #cbd5e1;
  text-decoration: none;
  font-size: 0.875rem;
  transition: color 0.3s ease;
}

.link-list a:hover {
  color: #3b82f6;
}

.footer-bottom {
  width: 100%;
}

.footer-divider {
  height: 1px;
  background: linear-gradient(90deg, transparent, #334155, transparent);
  margin-bottom: 24px;
}

.footer-meta {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;
}

.copyright {
  color: #94a3b8;
  font-size: 0.875rem;
}

.footer-badges {
  display: flex;
  gap: 16px;
}

.badge {
  background: rgba(59, 130, 246, 0.1);
  color: #60a5fa;
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 0.75rem;
  font-weight: 500;
}

.demo-notice {
  margin-top: 24px;
}

.demo-badge {
  background: #fef3c7;
  color: #92400e;
  padding: 8px 16px;
  border-radius: 8px;
  font-size: 0.875rem;
  font-weight: 600;
  border: 1px solid #f59e0b;
}

.disabled-link {
  color: #64748b;
  font-size: 0.875rem;
  cursor: not-allowed;
  text-decoration: line-through;
}

@media (max-width: 1024px) {
  .footer-main {
    grid-template-columns: 1fr;
    gap: 60px;
  }
  
  .footer-links {
    grid-template-columns: repeat(2, 1fr);
    gap: 40px;
  }
}

@media (max-width: 640px) {
  .footer-section {
    padding: 60px 0 20px;
  }
  
  .footer-main {
    gap: 40px;
  }
  
  .footer-links {
    grid-template-columns: 1fr;
    gap: 32px;
  }
  
  .footer-meta {
    flex-direction: column;
    text-align: center;
    gap: 16px;
  }
  
  .footer-badges {
    flex-wrap: wrap;
    justify-content: center;
  }
}
</style>